<template>
  <div :class="typeClass">
    <i :class="iconClass"></i>
    <span class="count-numbers">{{ Number(text).toLocaleString() }}</span>
    <span class="count-name text-uppercase">{{ title }}</span>
  </div>
</template>

<script>
import {} from "mdbvue";
export default {
  name: "AdminCard",
  components: {},
  props: ["title", "text", "icon", "type"],
  data: function() {
    return {};
  },
  methods: {},
  computed: {
    typeClass: function() {
      return "card-counter " + this.type;
    },
    iconClass: function() {
      return "fa " + this.icon;
    },
  },
};
</script>
